import Mutations from '../../odata/mutations';

export default { ...new Mutations('feedEmOrderLine'), ...new Mutations('feedEmOrderLines') };
